export class Element {
  public parent_id: number;
  public reportelementtype_id: number;
  public reportelementsize_id: number;
  public elementp_id: number;
  public name: string;
  public value: string;
  public index: number;
  public textalign_id: number;
  public fontfamily_id: number;
  public fontsize_id: number;
  public bold: boolean;
  public italic: boolean;
  public underline: boolean;
  public line_through: boolean;
  public fontcolor_id: number;
  public backgroundcolor_id: number;
  public elements: Element[] = new Array<Element>();

  constructor(reportelementtype_id: number, reportelementsize_id: number, elementp_id: number, name: string, value: string, index: number, textalign_id: number, fontfamily_id: number, fontsize_id: number, bold: boolean, italic: boolean, underline: boolean, line_through: boolean, fontcolor_id: number, backgroundcolor_id: number) {
    this.reportelementtype_id = reportelementtype_id;
    this.reportelementsize_id = reportelementsize_id;
    this.elementp_id = elementp_id;
    this.name = name;
    this.value = value;
    this.index = index;
    this.textalign_id = textalign_id;
    this.fontfamily_id = fontfamily_id;
    this.fontsize_id = fontsize_id;
    this.bold = bold;
    this.italic = italic;
    this.underline = underline;
    this.line_through = line_through;
    this.fontcolor_id = fontcolor_id;
    this.backgroundcolor_id = backgroundcolor_id;
  }
}
